import type { ErrorMap } from '@/app/error-registry';

export const TIME_TRACKING_START_ERROR_MAP: ErrorMap = {
  POST: {
    'Timer.AlreadyRunning': 'timeTracking:apiErrors.start.alreadyRunning',
    conflict: 'timeTracking:apiErrors.start.alreadyRunning',
    notFound: 'timeTracking:apiErrors.start.notFound',
    default: 'timeTracking:apiErrors.start.default',
  },
};

export const TIME_TRACKING_STOP_ERROR_MAP: ErrorMap = {
  POST: {
    'Timer.NotRunning': 'timeTracking:apiErrors.stop.notRunning',
    'Timer.NotFound': 'timeTracking:apiErrors.stop.notFound',
    conflict: 'timeTracking:apiErrors.stop.notRunning',
    notFound: 'timeTracking:apiErrors.stop.notFound',
    default: 'timeTracking:apiErrors.stop.default',
  },
};

/** POST /api/tasks/{taskId}/time — manual entry create. */
export const MANUAL_ENTRY_ERROR_MAP: ErrorMap = {
  POST: {
    'Task.NotFound': 'timeTracking:apiErrors.entry.notFound',
    'TimeEntry.Overlap': 'timeTracking:apiErrors.entry.overlap',
    conflict: 'timeTracking:apiErrors.entry.overlap',
    validation: 'timeTracking:apiErrors.entry.createDefault',
    forbidden: 'timeTracking:apiErrors.entry.createDefault',
    default: 'timeTracking:apiErrors.entry.createDefault',
  },
};

/** PUT / DELETE /api/time/{id} — edit / delete an entry. */
export const TIME_ENTRY_ERROR_MAP: ErrorMap = {
  PUT: {
    'TimeEntry.NotFound': 'timeTracking:apiErrors.entry.notFound',
    validation: 'timeTracking:apiErrors.entry.updateDefault',
    forbidden: 'timeTracking:apiErrors.entry.updateDefault',
    default: 'timeTracking:apiErrors.entry.updateDefault',
  },
  DELETE: {
    'TimeEntry.NotFound': 'timeTracking:apiErrors.entry.notFound',
    forbidden: 'timeTracking:apiErrors.entry.deleteDefault',
    default: 'timeTracking:apiErrors.entry.deleteDefault',
  },
};
